import { jsx as _jsx } from "react/jsx-runtime";
import { Portal } from "@air/primitive-portal";
import { memo } from "react";
import { PoweredByAir } from "~/components/PoweredByAir";
export const AnonymousSignUpOverlay = /*#__PURE__*/ memo(()=>/*#__PURE__*/ _jsx(Portal, {
        children: /*#__PURE__*/ _jsx("div", {
            "data-testid": "ANONYMOUS_SIGNUP_MODAL_OVERLAY",
            className: "pointer-events-none fixed inset-0 bg-black/60 backdrop-blur-sm",
            children: /*#__PURE__*/ _jsx(PoweredByAir, {})
        })
    }));
AnonymousSignUpOverlay.displayName = "AnonymousSignUpOverlay";
